const employmentTypes = [
  'שכיר',
  'עצמאי',
  'בעל שליטה',
  'עובד מדינה',
  'מובטל / מקבל קצבה',
]

export default employmentTypes